import { render, staticRenderFns } from "./index-step.vue?vue&type=template&id=39fed8ca&scoped=true&"
import script from "./index-step.vue?vue&type=script&lang=js&"
export * from "./index-step.vue?vue&type=script&lang=js&"
import style0 from "./index-step.vue?vue&type=style&index=0&id=39fed8ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fed8ca",
  null
  
)

component.options.__file = "index-step.vue"
export default component.exports